import styled from 'styled-components';
import { fromMd, hoverSupportMedia } from '../../constants';
export const StyledBaseAttributeSelectorContainer = styled.div.attrs({
    'data-test-id': 'base-attribute-selector',
}) `
  overflow-x: ${props => (props.disableMobileHorizontalSwipe ? 'unset' : 'scroll')};
  ${fromMd}, ${hoverSupportMedia} {
    overflow-x: unset;
  }

  /* Hide scrollbars */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
`;
export const StyledBaseAttributeSelector = styled.fieldset `
  display: inline-flex;

  &:focus {
    outline: none;
  }

  flex-wrap: ${props => (props.disableMobileHorizontalSwipe ? 'wrap' : 'nowrap')};
  ${fromMd}, ${hoverSupportMedia} {
    flex-wrap: wrap;
  }
`;
//# sourceMappingURL=styles.js.map